import React from "react";
import "../App.css";
import logo from "../assets/images/logo.svg";
import LanguagePicker from "./LanguagePicker";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();

  const goToHomepage = () => {
    navigate("/home")
  }

  return (
    <div className="header">
      <div className="logo-div">
        <img src={logo} className="logo" onClick={goToHomepage}></img>
      </div>
      <LanguagePicker/>
    </div>
  );
};

export default Header;
